/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Per-subsystem outcome as produced by the shadow auto-decisioning processor.
 * YES = passes; NO = blocks admission; UNRESOLVED = needs human review;
 * SKIPPED = not evaluated because the facility is configured to skip the
 * subsystem, and treated as a pass.
 * 
 * @export
 */
export const ShadowSubsystemOutcome = {
    Yes: 'YES',
    No: 'NO',
    Unresolved: 'UNRESOLVED',
    Skipped: 'SKIPPED'
} as const;
export type ShadowSubsystemOutcome = typeof ShadowSubsystemOutcome[keyof typeof ShadowSubsystemOutcome];


export function ShadowSubsystemOutcomeFromJSON(json: any): ShadowSubsystemOutcome {
    return ShadowSubsystemOutcomeFromJSONTyped(json, false);
}

export function ShadowSubsystemOutcomeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShadowSubsystemOutcome {
    return json as ShadowSubsystemOutcome;
}

export function ShadowSubsystemOutcomeToJSON(value?: ShadowSubsystemOutcome | null): any {
    return value as any;
}

